import HeaderText from "modules/1-on-1s/components/HeaderText/HeaderText";
import { convertDate } from "modules/1-on-1s/utils";
import React, {
  Dispatch,
  Fragment,
  SetStateAction,
  useContext,
  useEffect,
} from "react";
import { oneOnOneDetailListProps } from "modules/1-on-1s/types";
import "./OneOnOnePrepSurvey.scss";
import { ImageWithNameInitials, useUserProfile } from "components";
import { FormContext, MetaDataContext } from "contexts";
import { IMetadata, IRevieweeFormValues } from "interfaces";
import {
  getOneOnOne,
  getOneOnOneDetails,
  submitOneOnOne,
} from "data/teamble-ai-one-on-one";
import { finalize } from "rxjs";
import { getReviewTodoAnswers } from "data";
import { useFormik } from "formik";
import { getMappedRevieweeAnswers } from "modules/reviews/utils/utils";
import { Form } from "@themesberg/react-bootstrap";
import RevieweeFormQuestion from "modules/reviews/components/RevieweeFormQuestion";
import { REVIEWEE_FORM_VALIDATION_SCHEMA } from "validation-schemas";
import PrimaryButton from "modules/1-on-1s/components/PrimaryButton/PrimaryButton";

interface OneOnOnePrepSurveyProps {
  oneOnOneId: string;
  data: oneOnOneDetailListProps | null;
  setData: Dispatch<SetStateAction<oneOnOneDetailListProps | null>>;
}

const OneOnOnePrepSurvey: React.FC<OneOnOnePrepSurveyProps> = ({
  data,
  oneOnOneId,
  setData,
}) => {
  const { userProfile } = useUserProfile();
  const {
    multiSelectQuestionOptionsTypes: { options },
  } = useContext(MetaDataContext) as IMetadata;
  const [isLoading, setIsLoading] = React.useState(false);
  const [isSaving, setIsSaving] = React.useState(false);
  const metadata = React.useContext<IMetadata | null>(
    MetaDataContext
  ) as IMetadata;

  const isReviewer = userProfile?.teambleUserId === data?.reviewerId;
  const isReviewee = userProfile?.teambleUserId === data?.revieweeId;

  function getChoiceMappedValues(type: any, family: any, value: any) {
    if (type === "choice" && family !== "custom") {
      const familyOptions =
        options.find((option) => option.value === family)?.options || [];
      return familyOptions.find((option) => option.value === value)?.label;
    }
    return value;
  }
  const isEditEnabled = [data?.reviewerId, data?.revieweeId].includes(
    userProfile?.teambleUserId
  );
  const isAdmin =
    ![data?.reviewerId, data?.revieweeId].includes(
      userProfile?.teambleUserId
    ) && userProfile?.isSuperAdmin;

  function onSubmitHandler(data: IRevieweeFormValues) {
    setIsSaving(true);
    const responses = getMappedRevieweeAnswers(data.answers, metadata);
    submitOneOnOne(oneOnOneId, responses as any)
      .pipe(
        finalize(() => {
          revieweeForm.setSubmitting(false);
        })
      )
      .subscribe({
        next: (response: any) => {
          getOneOnOne(oneOnOneId)
            .pipe()
            .subscribe({
              next: (response: any) => {
                setIsSaving(false);
                setData(response?.data?.oneOnOne);
              },
              error: (error) => {
                console.log(error);
              },
            });
        },
        error: (error) => {
          console.log(error);
        },
      });
  }

  const revieweeForm = useFormik<IRevieweeFormValues>({
    initialValues: {
      answers: [],
    },
    // validationSchema: REVIEWEE_FORM_VALIDATION_SCHEMA,
    validationSchema: REVIEWEE_FORM_VALIDATION_SCHEMA,
    validateOnChange: true,
    validateOnBlur: true,
    onSubmit: onSubmitHandler,
  });

  console.log(revieweeForm.values, "ssss");
  useEffect(() => {
    setIsLoading(true);
    getOneOnOneDetails(oneOnOneId, false)
      .pipe(
        finalize(() => {
          setIsLoading(false);
        })
      )
      .subscribe({
        next: (response: any) => {
          const oneOnOne = response?.data?.data;
          const answers = oneOnOne?.answers;
          const responses = getReviewTodoAnswers(answers, metadata);
          revieweeForm.initialValues.answers = responses || [];
        },
        error: (error) => {
          console.log(error);
        },
      });
  }, [oneOnOneId, metadata]);

  const handleSubmitClick = () => {
    if (!revieweeForm.isSubmitting) {
      revieweeForm.handleSubmit();
    }
  };

  console.log({ data });

  return (
    <>
      <div className="one-on-one-prep-container">
        <div className="header-container">
          <HeaderText
            text={"Prep survey"}
            fontSize={"24px"}
            lineHeight={"24px"}
            letterSpacing={"-0.24px"}
          />
          <div className="right-header-container">
            <div className="subtext">
              {convertDate(
                (data?.state !== "closed"
                  ? data?.scheduledTimestamp?.toString()
                  : data?.startAt?.toString()) || ""
              ) ?? "Not Scheduled"}
            </div>
            {isEditEnabled && (
              <PrimaryButton
                isLoading={isSaving}
                loadingText={"Submitting..."}
                text={"submit"}
                onClick={handleSubmitClick}
              />
            )}
          </div>
        </div>

        <div className="container">
          {isLoading ? (
            <div className="edit-survey-loader">Loading prep survey...</div>
          ) : (
            <div>
              <Form
                className="d-flex overflow-hidden flex-column flex-grow-1 px-1"
                onSubmit={(e) => {}}
              >
                <FormContext.Provider value={revieweeForm}>
                  <div
                    style={{
                      gap: "20px",
                    }}
                    className="d-flex flex-column"
                  >
                    {revieweeForm?.values?.answers?.map((answer, index) => (
                      <Fragment key={index}>
                        {!isEditEnabled && (
                          <div>
                            {data?.blocks.find((item) => item.id === answer?.id)
                              ?.label ||
                              data?.blocks.find(
                                (item) => item.id === answer?.id
                              )?.text}
                          </div>
                        )}
                        {isEditEnabled && (
                          <RevieweeFormQuestion
                            key={index}
                            answer={answer}
                            index={index}
                            className={
                              answer.type === "short-text"
                                ? "PrepSurveyShortText"
                                : "PrepSurveyLongText"
                            }
                            labelClassName={
                              answer.type === "sub-title"
                                ? "prepSurveyDescriptionText"
                                : "prepSurveyLabelText"
                            }
                            descriptionClassName={"prepSurveyDescriptionText"}
                          />
                        )}

                        {(!isReviewer || isAdmin) &&
                          data?.reviewerChannelInfo?.value[answer.id]
                            ?.value && (
                            <div
                              title={data?.reviewerName}
                              className="survey-answer-container"
                            >
                              <div className="d-flex gap-3 align-items-center">
                                <ImageWithNameInitials
                                  label={data?.reviewerName}
                                  size="md"
                                />
                                <div className="name">{data?.reviewerName}</div>
                              </div>

                              <div className="answer-text">
                                {getChoiceMappedValues(
                                  answer.type,
                                  answer.family,
                                  data?.reviewerChannelInfo?.value[answer.id]
                                    ?.value
                                )}
                              </div>
                            </div>
                          )}
                        {(!isReviewee || isAdmin) &&
                          data?.revieweeChannelInfo?.value[answer.id]
                            ?.value && (
                            <div
                              title={data?.revieweeName}
                              className="survey-answer-container"
                            >
                              <div className="d-flex gap-3 align-items-center flex-1">
                                <ImageWithNameInitials
                                  label={data?.revieweeName}
                                  size="md"
                                />
                                <div className="name">{data?.revieweeName}</div>
                              </div>
                              <div className="answer-text flex-2">
                                {getChoiceMappedValues(
                                  answer.type,
                                  answer.family,
                                  data?.revieweeChannelInfo?.value[answer.id]
                                    ?.value
                                )}
                              </div>
                            </div>
                          )}
                      </Fragment>
                    ))}
                  </div>
                </FormContext.Provider>
              </Form>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default OneOnOnePrepSurvey;
